import type { AxiosPromise } from 'axios';
import { apiInstance } from '../base';

export const getPostView = (contentId: string): AxiosPromise<boolean> => {
  return apiInstance.get(`/raffle/check/${contentId}`);
};
